module.exports = __webpack_public_path__ + "VIPV38.png?51e51d35ea4196cc8df01bca99a66e1d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/colours/horses/VIPV38.png
// module id = 134
// module chunks = 0